// Fallback for a missing carrier logo PNG (SUP-1749). When
// /assets/cdn/flights/carriers/xsmall/{code}.png does not exist the <img>
// would otherwise render as a broken image with its alt text. We swap in a
// neutral plane placeholder instead. The SVG is self-contained (its stroke is
// visible on the white result card) so it needs no extra stylesheet.
export const CARRIER_LOGO_FALLBACK = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M17.8 19.2 16 11l3.5-3.5c1-1 1.5-2.4 1.5-3.5a2.12 2.12 0 0 0-2-2c-1.1 0-2.5.5-3.5 1.5L12 8 3.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z'/%3E%3C/svg%3E";

export const onCarrierLogoError = (e) => {
    const img = e.currentTarget;
    img.onerror = null;
    img.src = CARRIER_LOGO_FALLBACK;
};



// WEBPACK FOOTER //
// ./src/helpers/CarrierLogoFallback.js